import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import Barba from './components/Barba';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollSmoother } from 'gsap/ScrollSmoother';
gsap.registerPlugin(ScrollTrigger, ScrollSmoother);
import VideoModal from './components/VideoModal';
import global from './globalvars';
import { isTouch } from './utils';
import scrollLock from 'scroll-lock';
import '@lottiefiles/lottie-player';
import AutoplayVideos from './components/AutoplayVideos';

class Glu {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Glu.domReady()]).then(() => this.init());
	}

	init() {
		new Barba();

		this.VideoModal = document.querySelector('[data-video-modal]');
		if (!global.getVideoModal() && this.VideoModal) {
			global.setVideoModal(new VideoModal(this.VideoModal));
		}

		if (isTouch) {
			document.body.classList.add('body--touch');
		}

		// Huidige lock-status. Bij een verse page load is er niets om te ontgrendelen
		// (Barba's 'before' draait niet in de once-cyclus), dus starten we open.
		// Wie de scroll wil vasthouden stuurt zelf 'disable-scroll'.
		this.scrollLocked = false;

		// Global autoplay videos handler. Wordt aangemaakt bij de eerste DOMContentLoaded. Destroyed de videos bij 'unbless'
		this.autoplayVideos = new AutoplayVideos();

		// Smooth Scroll
		document.addEventListener('bless', (e) => {
			let mm = gsap.matchMedia();
			mm.add(
				{
					hasHover: '(hover: hover) and (pointer: fine)',
				},
				(context) => {
					let { hasHover } = context.conditions;

					if (hasHover) {
						// create the scrollSmoother before your scrollTriggers
						this.smoother = ScrollSmoother.create({
							wrapper: e.detail.element.querySelector('#smooth-wrapper'),
							content: e.detail.element.querySelector('#smooth-content'),
							normalizeScroll: false,
							ignoreMobileResize: true,
							smooth: 1,
							effects: true,
						});

						// Een nieuwe smoother krijgt de actuele lock-status. Zonder dit blijft
						// hij gepauzeerd als de matchMedia opnieuw matcht (viewport wisselen)
						// zonder dat er een Barba-transitie volgt die 'enable-scroll' stuurt.
						this.smoother.paused(this.scrollLocked);

						// Bij het reverten van de context kill't gsap de smoother zelf,
						// dus hier alleen onze referentie opruimen
						return () => {
							this.smoother = null;
						};
					}
				}
			);

			// Init autoplay videos op deze pagina
			this.autoplayVideos.init(e.detail.element);
		});

		window.addEventListener('disable-scroll', () => {
			this.scrollLocked = true;

			if (this.smoother) {
				if (this.smoother.paused()) {
					return;
				}
				this.smoother.paused(true);
			} else {
				scrollLock.disablePageScroll();
			}
		});

		window.addEventListener('enable-scroll', () => {
			this.scrollLocked = false;

			if (this.smoother && this.smoother.paused()) {
				this.smoother.paused(false);
			}

			// Altijd opheffen, ook als er nu een smoother is: de lock kan gezet zijn
			// toen er nog geen smoother was (mobiele viewport)
			scrollLock.clearQueueScrollLocks();
			scrollLock.enablePageScroll();
		});

		window.addEventListener('scroll-to-top', () => {
			if (this.smoother) {
				this.smoother.scrollTo(0, false);
			} else {
				window.scrollTo(0, 0);
			}
		});

		window.addEventListener('refresh-scroll', () => {
			ScrollTrigger.refresh();
		});
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Glu();
